const pressKitsAdmin = [
	{
		path: '/agency/press-kits/list',
		name: 'agency-press-kits-list',
		component: () => import('@/views/agency/press-kits/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-kits',
		},
	},
	{
		path: '/agency/press-kits/:id',
		name: 'agency-press-kits-show',
		component: () => import('@/views/agency/press-kits/show.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,press-kits',
		},
	},
]

export default pressKitsAdmin
